"use client"
import React, {useEffect, useState} from 'react';
import Post from "@/components/common/post/Post";
import {getFirstURISegment} from "@/utility/uriSegment.utility";
import Breadcrumbs from "@/components/common/BreadCrumb";
import PageHeader from "@/components/common/page-header";

function Page({params}) {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        let url = getFirstURISegment() + "/" + params.post;
        setUrl(url)
    }, [])

    const paths = [
        {name: "TRANG CHỦ", url: "/"},
        {name: "BẢNG GIÁ VẬN TẢI", url: "/bang-gia-van-tai-hang-hoa"},
        {name: "BẢNG GIÁ CHI TIẾT"}];
    return (
        <>
            <PageHeader title="Bảng giá chi tiết" />
           
            <div className="container-fluid" style={{marginTop: "20px"}}>
                <Breadcrumbs paths={paths}/>
            </div>
            {url ? <Post url={url}/> : ""}
        </>
    )
}

export default Page;